import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/eu-readiness-medtech")({
  head: () => buildRouteHead("/eu-readiness-medtech", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/eu-readiness-medtech", replace: true });
  },
});
